export const showLoader = (form: HTMLFormElement) => {
  const btnSubmit = document.querySelector(
    `[id="${form.getAttribute("id")}"] button[type=submit]`,
  ) as HTMLButtonElement | null;
  if (btnSubmit?.classList.contains("_loading")) return;
  const btnContent = btnSubmit?.firstElementChild as HTMLElement;
  const loader = document.createElement("div");
  loader.className = "loader";
  btnContent.style.display = "none";
  btnSubmit?.appendChild(loader);
  btnSubmit?.classList.add("_loading");
};
export const hideLoader = (form: HTMLFormElement) => {
  const btnSubmit = document.querySelector(
    `[id="${form.getAttribute("id")}"] button[type=submit]`,
  ) as HTMLButtonElement | null;
  const btnContent = btnSubmit?.firstElementChild as HTMLElement;
  const loader = document.querySelector(
    `[id="${form.getAttribute("id")}"] button[type=submit] .loader`,
  ) as HTMLButtonElement | null;
  loader && btnSubmit?.removeChild(loader);
  btnContent.style.display = "block";
  btnSubmit?.classList.remove("_loading");
};
